import { render } from "./HeaderOnboardingScreen.vue?vue&type=template&id=58e4f54a&scoped=true"
import script from "./HeaderOnboardingScreen.vue?vue&type=script&lang=js"
export * from "./HeaderOnboardingScreen.vue?vue&type=script&lang=js"

import "./HeaderOnboardingScreen.vue?vue&type=style&index=0&id=58e4f54a&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58e4f54a"]])

export default __exports__